module.exports = __webpack_public_path__ + "static/media/3.2bdf48f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/3.jpg
// module id = 238
// module chunks = 0